import React, { useState } from 'react';
import chevron_down from 'assets/icons/chevron_down.svg';

import SearchCombobox from './SearchCombobox';
import { FetchRemotePage } from './remotePage';

/** 値（送る文字）と名前。 */
export interface SearchSelectOption {
  value: string;
  label: string;
}

export interface SearchSelectProps {
  id: string;
  label: string;
  describedBy?: string;
  /** 選んでいる値（無ければ null・空）。 */
  value: string | null | undefined;
  onChange: (value: string) => void;
  /** サーバーの候補より前に必ず出す候補（機器の状態など）。 */
  fixedOptions?: SearchSelectOption[];
  /** サーバーの候補（機器に割り当てる運転者など）。 */
  fetchPage: FetchRemotePage<SearchSelectOption>;
  /** 候補に無い値の名前（編集を開いたときに割り当てられていた運転者など）。 */
  knownLabels?: Record<string, string>;
  ariaRequired?: boolean;
  invalid?: boolean;
  readOnly?: boolean;
}

/**
 * EV-493。1つを選ぶ欄（値は文字）を、文字を入れると候補をサーバーで検索する欄（SearchCombobox）にする。
 * 以前は <select> の選択肢に、候補を全件読んで並べていた（機器の状態と割り当てる運転者）。
 *
 * 選んでいる値の名前は、決まった候補・この欄で選んだ候補・knownLabels の順に探す（候補を読む前・今の検索の
 * 結果に無いときも名前を出す）。
 */
const SearchSelect: React.FC<SearchSelectProps> = ({
  id,
  label,
  describedBy,
  value,
  onChange,
  fixedOptions = [],
  fetchPage,
  knownLabels = {},
  ariaRequired,
  invalid,
  readOnly,
}) => {
  const [chosenLabels, setChosenLabels] = useState<Record<string, string>>({});
  const current = value ? String(value) : '';
  const name =
    fixedOptions.find((option) => option.value === current)?.label ??
    chosenLabels[current] ??
    knownLabels[current];
  const selected = current ? [{ value: current, label: name ?? '' }] : [];
  return (
    // 以前の <select> と同じく、右に下向きの印（飾り）を出す。
    <div className="relative">
    <SearchCombobox<SearchSelectOption>
      id={id}
      label={label}
      describedBy={describedBy}
      selected={selected}
      fetchPage={fetchPage}
      fixedOptions={fixedOptions}
      getKey={(option) => option.value}
      getLabel={(option) => option.label}
      onSelect={(option) => {
        setChosenLabels((labels) => ({ ...labels, [option.value]: option.label }));
        onChange(option.value);
      }}
      ariaRequired={ariaRequired}
      invalid={invalid}
      readOnly={readOnly}
      boxClassName="mt-1 min-h-[3rem] pr-10"
    />
      <div className="pointer-events-none absolute top-1 right-0 flex h-12 items-center pr-4">
        <img src={chevron_down} alt="" />
      </div>
    </div>
  );
};

export default SearchSelect;
